import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MicroQualificationService from "../../services/MicroQualificationService";

let initialState = {
    directions: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllTrainingDirections = createAsyncThunk(
    'getAllTrainingDirections',
    async ({page, limit}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await MicroQualificationService.getTrainingDirections(page, limit);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const trainingDirectionsSlice = createSlice({
    name: 'trainingDirectionsSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTrainingDirections.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllTrainingDirections.fulfilled, (state, action) => {
                state.isLoading = false;
                state.directions = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllTrainingDirections.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.directions = [];
                state.hasMore = false;
            })
    }
});

export const {} = trainingDirectionsSlice.actions;

export default trainingDirectionsSlice.reducer;